import "core-js/modules/es.array.push.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
const __default__ = {
  name: "MessageDetail",

  data() {
    return {
      fiscalYear: moment().add(-3, "month").year(),
      to: "students",
      filterOptions: {
        checkbox: [],
        classroom: false,
        type: false,
        keyword: ""
      },
      message_detail: {
        message: {
          student_sending_count: 0,
          student_opened_count: 0,
          participant_sending_count: 0,
          participant_opened_count: 0
        },
        enquete: {}
      },
      reSendTargets: [],
      checkAllFlag: false,
      showModal: false,
      isLoading: true,
      statuses: [],
      studentStatuses: [],
      participantStatuses: [],
      filteredStatuses: [],
      typeDropDown: [{
        slug: "email",
        label: "メール"
      }, {
        slug: "phone",
        label: "電話"
      }]
    };
  },

  head: {
    title: function () {
      return {
        inner: "お知らせ配信履歴詳細"
      };
    }
  },
  computed: { ...mapState(["classrooms", "studentAddress"]),
    activeClassrooms: function () {
      const l = this.statuses.map(v => v.class_id).filter((x, i, self) => self.indexOf(x) === i);
      return this.classrooms.filter(v => l.indexOf(v.id) > -1);
    },
    sendTargetsParam: function () {
      return this.to === "students" ? {
        students: this.reSendTargets,
        participants: []
      } : {
        students: [],
        participants: this.reSendTargets
      };
    }
  },
  watch: {
    to() {
      this.filterList();
    }

  },

  created() {
    this.setData();
  },

  methods: {
    setData() {
      getData("reader/get_message_detail/" + this.$route.params.id).then(data => {
        this.message_detail = data.items;
      }).catch(error => {
        console.log(error); // axiosのresponseが存在するエラーの時は一覧に戻る
        // if (error.response && this.$route.name !== "messages") {
        //   this.$router.push({ name: "messages" });
        // }
      });
      getData("reader/get_message_statuses/" + this.$route.params.id).then(data => {
        if (data) {
          const studentStatuses = data.items.students;
          this.statuses = this.studentStatuses = this.filteredStatuses = studentStatuses;
          this.participantStatuses = data.items.participants;

          if (studentStatuses && Object.keys(studentStatuses).length === 0 && data.items.participants.length > 0) {
            this.to = "participants";
          } else {
            this.to = "students";
          }
        }
      }).catch(error => {
        console.log(error); // axiosのresponseが存在するエラーの時は一覧に戻る
        // if (error.response && this.$route.name !== "messages") {
        //   this.$router.push({ name: "messages" });
        // }
      }).then(() => {
        this.isLoading = false;
      });
    },

    getJPTime(datetime) {
      return moment(datetime).format("llll");
    },

    getSendStatusJP(status) {
      let statusJP;

      switch (status) {
        case "error":
          statusJP = "未達";
          break;

        case "reached":
          statusJP = "未開封";
          break;

        case "opened":
          statusJP = "開封済";
          break;
      }

      return statusJP;
    },

    // すべてチェック ON / OFF
    checkAll() {
      if (this.checkAllFlag) {
        if (this.to === "students") {
          this.reSendTargets = this.filteredStatuses.map(v => v.id);
        } else {
          this.reSendTargets = this.filteredStatuses.map(v => v.participant.id);
        }
      } else {
        this.reSendTargets = [];
      }
    },

    // すべてチェック用チェックボックスの監視
    testAllChecked() {
      this.checkAllFlag = this.statuses.map(v => v.id).length === this.reSendTargets.length;
    },

    // リストのフィルタリング
    filterList() {
      let statuses = this.statuses = this.to === "students" ? this.studentStatuses : this.participantStatuses;

      if (this.filterOptions.checkbox.length > 0) {
        if (this.to === "students") {
          statuses = statuses.filter(v => this.filterOptions.checkbox.indexOf(v.status) > -1);
        } else {
          statuses = statuses.filter(v => this.filterOptions.checkbox.indexOf(v.final_status) > -1);
        }
      }

      if (this.filterOptions.type) {
        if (this.to === "students") {
          statuses = statuses.filter(v => {
            return v.guardian.filter(w => {
              return w.type === this.filterOptions.type;
            }).length > 0;
          });
        } else {
          statuses = statuses.filter(v => v.type === this.filterOptions.type);
        }
      }

      if (this.to === "students" && this.filterOptions.classroom) {
        statuses = statuses.filter(v => v.class_id === this.filterOptions.classroom);
      }

      if (this.filterOptions.keyword !== "") {
        statuses = statuses.filter(v => {
          return v.name && v.name.indexOf(this.filterOptions.keyword) > -1 || v.ruby && v.ruby.indexOf(this.filterOptions.keyword) > -1 || v.guardian.findIndex(v2 => v2.name && v2.name.indexOf(this.filterOptions.keyword) > -1) > -1 || v.guardian.findIndex(v2 => v2.ruby && v2.ruby.indexOf(this.filterOptions.keyword) > -1) > -1;
        });
      }

      this.filteredStatuses = statuses;
    },

    handleTo(val) {
      this.to = val;
    },

    downloadCSV() {
      let csvArray = [];

      if (this.to === "students") {
        csvArray = [["No", "クラス", this.studentAddress + "氏名", "ステータス", "保護者1氏名", "保護者1開封種別", "保護者1ステータス", "保護者1開封日時", "保護者2氏名", "保護者2開封種別", "保護者2ステータス", "保護者2開封日時", "保護者3氏名", "保護者3開封種別", "保護者3ステータス", "保護者3開封日時"]];
        this.filteredStatuses.forEach((v, i) => {
          let row = [i + 1, v.classroom_name, v.name, this.getSendStatusJP(v.status)];
          v.guardian.forEach(v2 => {
            row = row.concat([v2.name, v2.type === "email" ? "メール" : "電話", this.getSendStatusJP(v2.status), v2.status === "opened" ? this.getJPTime(v2.status_timestamps.updated_at) : ""]);
          }); // 保護者が3人以下の場合には空配列で列数を揃える

          if (row.length < 16) {
            row = row.concat(new Array(16 - row.length));
          }

          csvArray.push(row);
        });
      } else {
        csvArray = [["No", "氏名", "所属など", "種別", "ステータス", "開封日時"]];
        this.filteredStatuses.forEach((v, i) => {
          let row = [i + 1, v.participant.name, v.participant.belonging, v.type === "email" ? "メール" : "電話", this.getSendStatusJP(v.final_status), v.final_status === "opened" ? this.getJPTime(v.updated_at) : ""];
          csvArray.push(row);
        });
      }

      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      saveAs(new Blob([bom, Papa.unparse(csvArray)], {
        type: "text/csv;charset=utf-8"
      }), this.message_detail.content.subject + "_お知らせ配信状況.csv");
    }

  }
};
import moment from "moment";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import RowItem from "../RowItem";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import StatusRate from "./StatusRate.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    return {
      __sfc: true,
      RowItem,
      StatusRate
    };
  }

});